module.exports = __webpack_public_path__ + "static/media/icw_participantImg.1948cd91.svg";